module.exports = __webpack_public_path__ + "img/4-quad.7349a729.png";